import { Card, Row, Col, Table } from 'react-bootstrap';
import { ReviewDetailv2 } from 'components/reviews';
import './styles.scss';

export default function ReviewCardv2({
  name,
  title,
  description,
  date,
  rating,
  className = '',
  children,
  ...props
}) {
  return (
    <Table>
    <Row className={`ReviewRow pointer ${className}`} {...props}>
      <Col>
      <ReviewDetailv2
        name={name}
        title={title}
        description={description}
        date={date}
        rating={rating}
      >
      </ReviewDetailv2>
      </Col>
    </Row>
    <Row>{children}</Row>
    </Table>
   
  );
}
